import { UPDATE_FORM, RESET_FORM } from "../actions/DoctorForm.action";

const initialState = {
  start_date: "",
  end_date: "",
  client_id: "",
  program_ids: [],
  doctor_ids: [],
};

const DoctorformReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FORM:
      return { ...state, ...action.payload };

    case RESET_FORM:
      return { ...initialState };

    default:
      return state;
  }
};

export default DoctorformReducer;
